import createReactClass from 'create-react-class';

import {DESIGN} from '../global/libs/CONFIG.js';
import './Common.css';
import './AppNavbar.css';
import PropTypes from 'prop-types';
import {MaterialSymbol} from 'react-material-symbols';
import 'react-material-symbols/outlined';

let AppNavbar = createReactClass({
  propTypes: {
    gotoQuestionPanel: PropTypes.func.isRequired
  },

  // ARGS: gotoQuestionPanel
  handleHomeClick: function () {
    this.props.gotoQuestionPanel();
    return false;
  },

  render: function () {
    let homeLink = (
      <a role="button" onClick={this.props.gotoQuestionPanel}>
        <MaterialSymbol icon="home" fill size={23} />
      </a>
    );

    return (
      <span>
        <div className="navbar">
          <div className="navbar-header">
            <a role="button" className="navbar-brand" onClick={this.handleHomeClick}>
              <b>{DESIGN.FRONT_TITLE}</b>
            </a>
          </div>
          <div>
            <ul className="nav pull-right">
              <li>{homeLink}</li>
              <li>{DESIGN.HELPLINK}</li>
              <li>{DESIGN.SITELINK}</li>
            </ul>
          </div>
        </div>
      </span>
    );
  }
});

export default AppNavbar;
